
import type { ReactNode } from 'react';
import type { StaticImageData } from 'next/image';
import monthImg from './images/privileges/vip-month-icon.png';
import domainImg from './images/privileges/vip-domain-icon.png';
import vip1LevelIcon from './images/vip/vip1.png';
import vip2LevelIcon from './images/vip/vip2.png';
import vip3LevelIcon from './images/vip/vip3.png';
import vip4LevelIcon from './images/vip/vip4.png';
import vip5LevelIcon from './images/vip/vip5.png';
import vip6LevelIcon from './images/vip/vip6.png';
import vip7LevelIcon from './images/vip/vip7.png';
import vip8LevelIcon from './images/vip/vip8.png';
import vip9LevelIcon from './images/vip/vip9.png';
import vip10LevelIcon from './images/vip/vip10.png';
import vip11LevelIcon from './images/vip/vip11.png';
import vip12LevelIcon from './images/vip/vip12.png';
import vip13LevelIcon from './images/vip/vip13.png';
import vip14LevelIcon from './images/vip/vip14.png';
import vip15LevelIcon from './images/vip/vip15.png';

import sideLevel1CardBg from './images/card/side-level1-card-bg.png';
import sideLevel2CardBg from './images/card/side-level2-card-bg.png';
import sideLevel3CardBg from './images/card/side-level3-card-bg.png';

import level1CardBg from './images/card/level1-card-bg.png';
import level2CardBg from './images/card/level2-card-bg.png';
import level3CardBg from './images/card/level3-card-bg.png';

// privileges 权益
import card2Bg from '@/features/user-vip/images/privileges/vip-privileges-card2-bg.png';
import privilegesLevelUpIcon from '@/features/user-vip/images/privileges/vip-privileges-upgrade-icon.png';
import loseReturnImg from '@/features/user-vip/images/privileges/vip-privileges-cashback-icon.png';
import dayImg from '@/features/user-vip/images/privileges/vip-privileges-daily-icon.png';
import weeklyImg from '@/features/user-vip/images/privileges/vip-privileges-week-icon.png';
import rewardNicknameImg from '@/features/user-vip/images/privileges/vip-privileges-nickname-icon.png';
import withdrawBenefitImg from '@/features/user-vip/images/privileges/vip-privileges-withdraw-benefit-icon.png';
import dedicatedSupportImg from '@/features/user-vip/images/privileges/vip-privileges-dedicated-support-icon.png';
import largeAmountWithdrawImg from '@/features/user-vip/images/privileges/vip-privileges-large-amount-withdraw-icon.png';
import priorityWithdrawImg from '@/features/user-vip/images/privileges/vip-privileges-priority-withdraw-icon.png';
import exclusiveChannelImg from '@/features/user-vip/images/privileges/vip-privileges-exclusive-channel-icon.png';

export enum BenefitType {
  lose_return = 'lose_return', // 现金返还
  loss_return = 'loss_return', // 现金返还
  daily_reward = 'daily_reward', // 每日奖励
  monthly_reward = 'monthly_reward', // 每月奖励
  weekly_reward = 'weekly_reward', // 每周奖励  
  upgrade_reward = 'upgrade_reward', // 晋级奖励
  withdraw_benefit = 'withdraw_benefit', // 提现权益
  priority_withdraw = 'priority_withdraw',  // 优先提现
  large_amount_withdraw = 'large_amount_withdraw', // 大额提现
  custom_nickname = 'custom_nickname', // 自定义昵称
  dedicated_support = 'dedicated_support',  // 专属客服
  super_vip_support = 'super_vip_support',  // 超级 VIP 客服
  exclusive_channel = 'exclusive_channel', // 专属频道
  custom_domain = 'custom_domain', // 专属域名
}

export enum RewardType {
  daily = 'daily',
  weekly = 'weekly',
  cashback = 'cashback',
  monthly = 'monthly',
  upgrade = 'upgrade'
}

// claimable 可领取 claimed 已领取 expired 已过期 locked 不可领取
export enum RewardCoinType {
  claimable = 'claimable',
  claimed = 'claimed',
  expired = 'expired',
  locked = 'locked'
}

export enum RewardStatus {
  claimable = 1,
  claimed = 2,
  expired = 3,
  locked = 4
};

export const benefitMap: Record<BenefitType, {
  cardIconSrc: StaticImageData;
  cardBg?: StaticImageData;
  title: string | ReactNode;
  subTitle?: string | ReactNode;
  desc: string | ReactNode;
}> = {
  [BenefitType.lose_return]: {
    cardIconSrc: loseReturnImg,
    cardBg: card2Bg,
    title: 'benefits.cashback',
    subTitle: 'newVip.benefits.cashbackOnLosses',
    desc: 'descriptions.cashbackRate',
  },
  [BenefitType.loss_return]: {
    cardIconSrc: loseReturnImg,
    cardBg: card2Bg,
    title: 'benefits.cashback',
    subTitle: 'newVip.benefits.cashbackOnLosses',
    desc: 'descriptions.cashbackRate',
  },
  [BenefitType.monthly_reward]: {
    cardIconSrc: monthImg,
    cardBg: card2Bg,
    title: 'benefits.monthlyBonus',
    subTitle: 'benefits.cashback',
    desc: 'descriptions.monthlyBonusCalculation',
  },
  [BenefitType.weekly_reward]: {
    cardIconSrc: weeklyImg,
    cardBg: card2Bg,
    title: 'benefits.weeklyBonus',
    subTitle: 'newVip.playMore',
    desc: 'descriptions.weeklyBonusCalculation',
  },
  [BenefitType.upgrade_reward]: {
    cardIconSrc: privilegesLevelUpIcon,
    cardBg: card2Bg,
    title: 'benefits.levelUpBonus',
    subTitle: 'newVip.upgradeToClaim',
    desc: 'descriptions.levelUpReward',
  },
  [BenefitType.withdraw_benefit]: {
    cardIconSrc: withdrawBenefitImg,
    cardBg: card2Bg,
    title: 'newVip.benefits.free',
    desc: 'descriptions.freeWithdrawalCount',
  },
  [BenefitType.priority_withdraw]: {
    cardIconSrc: priorityWithdrawImg,
    cardBg: card2Bg,
    title: 'newVip.priorityWithdrawal',
    desc: 'descriptions.priorityWithdrawal',
  },
  [BenefitType.large_amount_withdraw]: {
    cardIconSrc: largeAmountWithdrawImg,
    cardBg: card2Bg,
    title: 'benefits.largeWithdrawal',
    desc: 'descriptions.withdrawalLimit',
  },
  [BenefitType.custom_nickname]: {
    cardIconSrc: rewardNicknameImg,
    cardBg: card2Bg,
    title: 'newVip.benefits.nickname',
    desc: 'descriptions.nicknameCustomization',
  },
  [BenefitType.dedicated_support]: {
    cardIconSrc: dedicatedSupportImg,
    cardBg: card2Bg,
    title: 'newVip.benefits.vipSupport',
    desc: 'descriptions.dedicatedSupport',
  },
  [BenefitType.super_vip_support]: {
    cardIconSrc: dedicatedSupportImg,
    cardBg: card2Bg,
    title: 'newVip.benefits.24Support',
    desc: 'descriptions.vipSupport',
  },
  [BenefitType.exclusive_channel]: {
    cardIconSrc: exclusiveChannelImg,
    cardBg: card2Bg,
    title: 'newVip.benefits.dedicatedAccess',
    desc: 'descriptions.exclusiveChannel',
  },
  [BenefitType.custom_domain]: {
    cardIconSrc: domainImg,
    cardBg: card2Bg,
    title: 'benefits.customDomain',
    desc: 'descriptions.customDomain',
  },
  [BenefitType.daily_reward]: {
    cardIconSrc: dayImg,
    cardBg: card2Bg,
    title: 'benefits.dailyBonus',
    subTitle: 'newVip.amountDays',
    desc: 'descriptions.dailyBonusCalculation',
  },
};

// vip等级信息
export const levelMap: Record<number, any> = {
  0: {
    cardBg: sideLevel1CardBg.src,
    bigCardBg: level1CardBg.src,
    levelIcon: vip1LevelIcon
  },
  1: {
    cardBg: sideLevel1CardBg.src,
    bigCardBg: level1CardBg.src,
    levelIcon: vip1LevelIcon
  },
  2: {
    cardBg: sideLevel1CardBg.src,
    bigCardBg: level1CardBg.src,
    levelIcon: vip2LevelIcon
  },
  3: {
    cardBg: sideLevel1CardBg.src,
    bigCardBg: level1CardBg.src,
    levelIcon: vip3LevelIcon
  },
  4: {
    cardBg: sideLevel1CardBg.src,
    bigCardBg: level1CardBg.src,
    levelIcon: vip4LevelIcon
  },
  5: {
    cardBg: sideLevel1CardBg.src,
    bigCardBg: level1CardBg.src,
    levelIcon: vip5LevelIcon
  },
  6: {
    cardBg: sideLevel2CardBg.src,
    bigCardBg: level2CardBg.src,
    levelIcon: vip6LevelIcon
  },
  7: {
    cardBg: sideLevel2CardBg.src,
    bigCardBg: level2CardBg.src,
    levelIcon: vip7LevelIcon
  },
  8: {
    cardBg: sideLevel2CardBg.src,
    bigCardBg: level2CardBg.src,
    levelIcon: vip8LevelIcon
  },
  9: {
    cardBg: sideLevel2CardBg.src,
    bigCardBg: level2CardBg.src,
    levelIcon: vip9LevelIcon
  },
  10: {
    cardBg: sideLevel2CardBg.src,
    bigCardBg: level2CardBg.src,
    levelIcon: vip10LevelIcon
  },
  11: {
    cardBg: sideLevel3CardBg.src,
    bigCardBg: level3CardBg.src,
    levelIcon: vip11LevelIcon
  },
  12: {
    cardBg: sideLevel3CardBg.src,
    bigCardBg: level3CardBg.src,
    levelIcon: vip12LevelIcon
  },
  13: {
    cardBg: sideLevel3CardBg.src,
    bigCardBg: level3CardBg.src,
    levelIcon: vip13LevelIcon
  },
  14: {
    cardBg: sideLevel3CardBg.src,
    bigCardBg: level3CardBg.src,
    levelIcon: vip14LevelIcon
  },
  15: {
    cardBg: sideLevel3CardBg.src,
    bigCardBg: level3CardBg.src,
    levelIcon: vip15LevelIcon
  }
};

export const vipLevelIconMap: StaticImageData[] = [
  vip1LevelIcon,
  vip2LevelIcon,
  vip3LevelIcon,
  vip4LevelIcon,
  vip5LevelIcon,
  vip6LevelIcon,
  vip7LevelIcon,
  vip8LevelIcon,
  vip9LevelIcon,
  vip10LevelIcon,
  vip11LevelIcon,
  vip12LevelIcon,
  vip13LevelIcon,
  vip14LevelIcon,
  vip15LevelIcon,
];

export const CURRENCY_SYMBOL_MAP = {
  USDT: '$',
  INR: '₹',
  BRL: 'R$',
};

export const CASHBACK_LOSE_RETURN_CYCLE = {
  DAILY: 'daily',
  WEEKLY: 'weekly'
};

// 'en-US', 'hi-IN', 'ur-PK', 'pt-BR', 'es-MX'
export const VIP_BANNER = {
  'en': () => import('@/features/user-vip/images/banner/en-US.png'),
  'en-US': () => import('@/features/user-vip/images/banner/en-US.png'),
  'hi-IN': () => import('@/features/user-vip/images/banner/hi-IN.png'),
  'hi': () => import('@/features/user-vip/images/banner/hi-IN.png'),
  'pt-BR': () => import('@/features/user-vip/images/banner/pt-BR.png'),
  'pt': () => import('@/features/user-vip/images/banner/pt-BR.png'),
}

